import "./App.css";
import { BrowserRouter } from "react-router-dom";
import MainLayout from "./layout/MainLayout";
import MainRouter from "./router/mainRouter";

function App() {
  return (
    <BrowserRouter>
      <MainRouter />
    </BrowserRouter>
  );
}

export default App;
